export enum Licenses {
  TemplatePremium = 'template_premium_video',
  PhotoChooserPremium = 'premium',
  PhotoChooserFree = 'fte',
  StockVideoFree = 'stock_video_fte',
  StockVideoPremium = 'stock_video_premium',
  ShutterstockVideo = 'shutterstock_video'
}
